import { z } from "zod";

export const ResultDataSchema = z.object({
  Page: z.number(),
  PageCount: z.number().optional(),
  PageSize: z.number(),
  TotalCount: z.number().optional(),
});

export type ResultDataType = z.infer<typeof ResultDataSchema>;
